import Vue from 'vue'
import VueRouter from 'vue-router'
 import Home from '../views/Home.vue'
import Share from '../views/Share.vue'
import Login from "../views/Login";
import Detail from "@/views/Detail";

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/vehicle/:vehicleId',
    name: 'detail',
    props: true,
    component: Detail,
    meta: {
      canGoBack: true
    }
  },
  {
    path: '/share',
    name: 'share',
    component: Share
  },
  {
    path: '*',
    redirect: 'home'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
